import { Link } from 'react-router-dom';
import styles from './HomeNav.module.css';

/**
 * 홈페이지 전용 sticky 상단 nav. #why/#levels/#schedule 는 홈페이지 내부 섹션 앵커,
 * "가맹 프로세스"는 별도 라우트(/process)로 이동한다.
 */
export default function HomeNav() {
  return (
    <nav id="top" className={styles.nav}>
      <div className={`wrap ${styles.inner}`}>
        <a href="#top" className={styles.logo}>
          <img src="/assets/logo_ko_cut.png" alt="잉글리시팝" className={styles.logoImg} />
        </a>
        <ul className={styles.links}>
          <li>
            <a href="#why">브랜드 소개</a>
          </li>
          <li>
            <a href="#levels">레벨 시스템</a>
          </li>
          <li>
            <a href="#schedule">설명회 일정</a>
          </li>
          <li>
            <Link to="/process">가맹 프로세스</Link>
          </li>
        </ul>
        <a href="tel:1660-0540" className={styles.tel} aria-label="가맹 상담 전화 1660-0540">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          1660-0540
        </a>
      </div>
    </nav>
  );
}
